import React from 'react'
import '../pages/css/Home.css';
import Entertaiment1 from '../images/communication1.jpg';
import Entertaiment2 from '../images/communication2.jpg';
import Entertaiment3 from '../images/communication3.jpg';
import banner from '../images/communication-banner.jpg';


function MediaCommunication() {
    return (
        <>   <section
            id="contact-section-page"
            style={{
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                position: 'relative', // Important for overlay
                zIndex: 1,
            }}
        >
            {/* Overlay */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)', // semi-transparent black
                    zIndex: 2,
                }}
            ></div>

            <section className="container-fluid px-3 px-md-5 pt-3 pb-5" style={{ position: 'relative', zIndex: 3 }}>
                <div className="row justify-content-center text-center">
                    <div className="col-lg-10">
                        <h1 className="fw-bold display-5 text-white" style={{ fontSize: '3rem' }}>Media Communication
                        </h1>
                        <p className="fs-2 fw-medium text-white mt-3">
                          Build intelligent systems for device control, automation, testing, and digital transformation in the electronics ecosystem.
                        </p>
                    </div>
                </div>
            </section>
        </section>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">Our  <span className="highlight-orange">Media & Communication</span> Services
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Media Production & Communication Platforms */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={Entertaiment1}
                            alt="Media Communication Platforms"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Media &</span> Communication
                        </h1>

                        <p className="mb-4">
                            <h2>Empowering modern media houses and communication networks with custom digital platforms and broadcasting tools.</h2>
                        </p>

                        <h6 className="fw-bold mb-2 highlight-orange">Key Highlight:</h6>
                        <p className="mb-4 ps-3">
                            <h4>From live-streaming solutions and newsroom automation to content management and communication APIs — we build platforms that connect, inform, and engage audiences in real-time.</h4>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Broadcasting, Content Delivery & Monetization */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Digital Media</span> Solutions
                        </h1>

                        <p className="mb-4">
                            <h2>Build end-to-end platforms for publishing, broadcasting, and monetizing digital content across multiple channels.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Live Broadcasting</h4>
                        <p className="mb-2 ps-3">
                            <h5>Implement high-speed streaming and broadcast systems with RTMP, HLS, and adaptive bitrate streaming capabilities.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Content Management Systems</h4>
                        <p className="mb-2 ps-3">
                            <h5>Custom CMS solutions for news portals, radio networks, blogs, and video platforms with dynamic editorial tools.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Ad Tech & Monetization</h4>
                        <p className="mb-2 ps-3">
                            <h5>Integrate ad servers, programmatic advertising, and paywall models to drive revenue from digital content.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Audience Engagement Tools</h4>
                        <p className="mb-2 ps-3">
                            <h5>Enable chat, comments, polls, social sharing, and real-time feedback mechanisms to keep viewers engaged.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={Entertaiment2}
                            alt="Live Media and Broadcasting Tools"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Communication APIs, Chat & Newsroom Systems */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={Entertaiment3}
                            alt="Media Communication Infrastructure"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Communication</span> Infrastructure
                        </h1>

                        <p className="mb-4">
                            <h2>Build scalable communication APIs, newsroom platforms, and messaging systems to power modern media operations.</h2>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Real-Time Messaging</h4>
                        <p className="mb-2 ps-3">
                            <h5>Develop in-app messaging, push notifications, and alerts using WebSocket and third-party APIs like Twilio or Firebase.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Newsroom Automation</h4>
                        <p className="mb-2 ps-3">
                            <h5>Streamline editorial workflows with integrated publishing dashboards, scheduling, and media asset management.</h5>
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Unified Communication Platforms</h4>
                        <p className="mb-2 ps-3">
                            <h5>Integrate video calls, VoIP, chatbots, and live assistance tools into your media ecosystem for dynamic communication.</h5>
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>
            </section>

        </>
    )
}

export default MediaCommunication